import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { hasTokenExpired, hasPermission } from '../utils';
import LoginRedirect from './LoginRedirect';
function PrivateRoute({ render, roles, ...rest }) {
    const { user } = useAuth();
    return (React.createElement(Route, { ...rest, render: props => {
            if (hasTokenExpired())
                return React.createElement(LoginRedirect, null);
            if (user.staff || hasPermission(user, roles))
                return render(props);
            return (React.createElement(Redirect, { to: {
                    pathname: '/',
                    state: { from: props.location },
                } }));
        } }));
}
export default PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map